/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { UserContextInput } from './userContextInput';

export type UserCreateContext = UserContextInput | null;
